import axios from "axios";

const prepareData = (data) => {return {project_status:data}}

// Plural Actions
export const GET_PROJECT_STATUSES = "get_project_statuses";
export const getProjectStatuses = () => {
	const url = `/project/statuses.json`
	const request = axios.get(url);
	return {
		type: GET_PROJECT_STATUSES,
		payload: request
	};
};


// Singular Actions
export const CREATE_PROJECT_STATUS = "create_project_status";
export const createProjectStatus = (data) => {
	const url = `/project/statuses.json`
	const request = axios({method: "post",url: url,data: prepareData(data)});
	return {
		type: CREATE_PROJECT_STATUS,
		payload: request
	};
};

export const GET_PROJECT_STATUS = "get_project_status";
export const getProjectStatus = (id) => {
	const url = `/project/statuses/${id}.json`
	const request = axios.get(url);
	return {
		type: GET_PROJECT_STATUS,
		payload: request
	};
};

export const UPDATE_PROJECT_STATUS = "update_project_status";
export const updateProjectStatus = (id,data) => {
	const url = `/project/statuses/${id}.json`
	const request = axios({method: "patch",url: url,data: prepareData(data)});
	return {
		type: UPDATE_PROJECT_STATUS,
		payload: request
	};
};

export const DESTROY_PROJECT_STATUS = "destroy_project_status";
export const destroyProjectStatus = (id) => {
	const url = `/project/statuses/${id}.json`
	const request = axios({method: "delete",url: url});
	return {
		type: DESTROY_PROJECT_STATUS,
		payload: request
	};
};
